exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".GetCustomerForm {\n  background: #212121dd;\n  padding: 20px;\n  border-radius: 3px;\n  display: inline-grid;\n  grid-gap: 1rem;\n  gap: 1rem; }\n", ""]);

